export function setMergedRef(
  node: HTMLElement | null,
  setAnchor: (node: HTMLElement | null) => void,
  existingRef: unknown,
) {
  setAnchor(node)
  if (typeof existingRef === 'function') {
    existingRef(node)
  } else if (existingRef && typeof existingRef === 'object' && 'current' in existingRef) {
    (existingRef as { current: unknown }).current = node
  }
}
